<template>
  <el-container class="full-height">

    <el-aside class="menu-wrapper" width="230px">
      <!-- <div class="full-height"> -->

      <header>
          <img v-if="isp.logo_for_white" :src="isp.logo_for_white" :alt="isp.name" class="isp">
          <img v-else src="./assets/youtv_logo_isp_console_top.svg" alt="" class="isp">
      </header>
      <sidemenu class="menu"></sidemenu>

      <!-- </div> -->
      <el-footer height="40px">
        {{this.description}} • v{{this.version}}<br>© {{new Date().getFullYear()}} <a href="http://youtv.com.ua" title="youtv.com.ua" target="_blank">youtv.com.ua</a>
      </el-footer>
    </el-aside>

    <el-main class="main">
      <router-view></router-view>
    </el-main>

  </el-container>
</template>

<script>

  import store from './store'
  import { mapGetters, mapActions } from 'vuex'
  import sidemenu from './components/sidemenu.vue'

  export default {

    beforeRouteEnter (to, from, next) {
      document.title = 'youtv ISP Console'
      store.getters.isUserLoggedIn ? next() : next('/login')
    },

    components: {
      sidemenu
    },

    computed: {
      ...mapGetters(['user', 'isp'])
    },

    data () {
      return {
        version: VERSION,
        description: DESCRIPTION
      }
    }
  }

</script>

<style lang="scss">

</style>